<template>
  <div class="vx-row" id="pages">
    <div class="vx-col w-full">
      <vx-card>
        <form id="posts">
          <div class="vx-row mt-4">
            <div class="vx-col sm:w-3/4 w-full">
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.title"
                    name="postTitle"
                    :label="$t('Title')"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('postTitle')"
                    >{{ errors.first("postTitle") }}</span
                  >
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.englishName"
                    name="englishName"
                    :label="$t('EnglishName')"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('englishName')"
                    >{{ errors.first("englishName") }}</span
                  >
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <b>{{ $t("Description") }}</b>

                  <quill-editor
                    v-model="model.description"
                    :options="editorDescription"
                    :label="$t('Description')"
                    height="250"
                  >
                  </quill-editor>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-textarea
                    v-model="model.shortDescription"
                    name="pageSubTitle"
                    :label="$t('ShortDescription')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-textarea
                    v-model="model.metaDescription"
                    :label="$t('MetaDescription') + $t('MaximumCharacters')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-textarea
                    v-model="model.conclusion"
                    :label="$t('Conclusion')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.metaKeyword"
                    :label="$t('KeyWords')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.sourceTitle"
                    :label="$t('SourceTitle')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.sourceLink"
                    :label="$t('SourceLink')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.urlSlug"
                    :label="$t('URLSlug')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.pros"
                    :label="$t('Pros')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.cons"
                    :label="$t('Cons')"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @edit-image="editImage"
                    :data-images="images"
                    :maxImage="1"
                    :dragText="$t('DragAndDrop')"
                    idUpload="image"
                    idEdit="editImage"
                    :browseText="$t('UploadImage')"
                    :showPrimary="false"
                  ></vue-upload-multiple-image>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-input
                    class="inputx"
                    v-model="model.point"
                    name="postRate"
                    v-validate="{ regex: '^([0-9]+)$' }"
                    :label="$t('PostRate')"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('postRate')"
                    >{{ errors.first("postRate") }}</span
                  >
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <label class="vs-select--label">{{
                    $t("PostCategories")
                  }}</label>
                  <v-select
                    label="title"
                    :options="allPostCat"
                    v-model="model.postCategories"
                    :reduce="x => ({ categoryId: x.id, title: x.title })"
                    multiple
                    dir="rtl"
                  >
                  </v-select>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <label class="vs-select--label">{{ $t("Tags") }}</label>
                  <v-select
                    label="name"
                    :options="allPostTags"
                    v-model="model.postTags"
                    :reduce="x => ({ tagId: x.id, name: x.name })"
                    multiple
                    dir="rtl"
                  >
                  </v-select>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <label class="vs-select--label datepicker-lb">{{
                    $t("PublishDate")
                  }}</label>

                  <date-picker
                    v-model="model.publishDate"
                    type="datetime"
                    format="jYYYY-jMM-jDD HH:mm:ss"
                    display-format="jYYYY-jMM-jDD HH:mm:ss"
                    class="date-picker"
                    :label="$t('PublishDate')"
                    :clearable="true"
                  />
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vue-upload-multiple-image
                    @upload-success="uploadCoverImageSuccess"
                    @before-remove="beforeCoverRemove"
                    @edit-image="editCoverImage"
                    :data-images="coverImages"
                    :maxImage="1"
                    :dragText="$t('DragAndDrop')"
                    idUpload="cover"
                    idEdit="editCover"
                    :browseText="$t('CoverImage')"
                    :showPrimary="false"
                  ></vue-upload-multiple-image>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="model.showInHeader">{{
                    $t("ShowInHeader")
                  }}</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="model.pinToTop">{{
                    $t("PinToTop")
                  }}</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="model.hideSideBar">{{
                    $t("HideSideBar")
                  }}</vs-checkbox>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="model.showInHome">{{
                    $t("ShowInHome")
                  }}</vs-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                class="mb-2 submit-btn bg_l_green float-right mr-4"
                @click.prevent="submitForm"
                :disable="disabled"
                >{{ $t("Submit") }}</vs-button
              >
              <router-link
                :to="{ path: '/Blog/Index' }"
                class="vs-component vs-button back-btn"
                color="rgb(62, 201, 214)"
                type="filled"
              >
                {{ $t("BackToList") }}
              </router-link>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
.con-vs-checkbox {
  margin: 5px 0;
}

.date-picker label {
  width: 115px !important;
}

.vpd-input-group .vpd-clear-btn {
  left: 115px;
  top: 0px;
}
#posts .image-container {
  width: 100% !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { Validator } from "vee-validate";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    postTitle: {
      required: "لطفا عنوان را وارد نمایید."
    },
    englishName: {
      required: "لطفا عنوان انگلیسی را وارد نمایید."
    },
    postRate: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید."
    }
  }
};
Validator.localize("fa", dict);

export default {
  name: "Content_Managment_Posts_Create",
  data() {
    return {
      model: {
        postTags: [],
        postCategories: [],
        title: "",
        shortDescription: "",
        coverImage: "",
        image: "",
        description: "",
        publishDate: "",
        metaDescription: "",
        metaKeyword: "",
        pros: "",
        cons: "",
        conclusion: "",
        sourceTitle: "",
        sourceLink: "",
        point: "",
        urlSlug: "",
        viewCount: null,
        showInHeader: true,
        pinToTop: true,
        hideSideBar: true,
        showInHome: true,
        englishName: ""
      },
      editorDescription: {
        placeholder: ""
      },
      disabled: false,
      images: [],
      coverImages: []
    };
  },
  components: {
    "v-select": vSelect,
    quillEditor,
    VueUploadMultipleImage
  },
  mounted() {
    this.fetchPostCategories();
    this.fetchTags();
  },
  computed: {
    ...mapGetters({
      allPostCat: "postcategory/list",
      allPostTags: "tag/list"
    })
  },
  methods: {
    ...mapActions({
      createPost: "post/create",
      fetchPostCategories: "postcategory/fetch",
      fetchTags: "tag/fetch"
    }),

    uploadImageSuccess(formData, index, fileList) {
      this.model.image = fileList[index].path;
    },
    beforeRemove(index, done) {
      done();
      this.model.image = "";
    },
    editImage(formData, index, fileList) {
      this.model.image = fileList[index].path;
    },

    uploadCoverImageSuccess(formData, index, fileList) {
      this.model.coverImage = fileList[index].path;
    },
    beforeCoverRemove(index, done) {
      done();
      this.model.coverImage = "";
    },
    editCoverImage(formData, index, fileList) {
      this.model.coverImage = fileList[index].path;
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.createPost(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              });
              this.disabled = false;
            })
            .then(() => this.$router.push("/Blog/Index"))
            .catch(() => {
              this.disabled = false;
            });
        } else {
          this.$swal({
            position: "center-center",
            type: "error",
            text: "خطا در ثبت رکورد!",
            showConfirmButton: false,
            timer: 8000
          });
        }
      });
    }
  }
};
</script>
